import styled from "@emotion/styled";
import { Box, Button, Typography } from "@mui/material";

const MainHeadWrap = styled("div")({
  position: "absolute",
  top: "50%",
  left: "50%",
  "@media (max-width: 768px)": {
    top: "50%",
    left: "0",
    textAlign: "center",
  },
  "@media (max-width: 425px)": {
    top: "35%",
  },
});

const MainHead = styled(Typography)(() => ({
  fontSize: "40px",
  fontWeight: "bold",
  "@media (max-width: 768px)": {
    fontSize: "20px",
  },
}));

const MainContent = styled(Typography)(() => ({
  marginTop: "20px",
  marginRight: "50px",
}));

const BrandMotionSection = styled("div")({
  overflow: "hidden",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  backgroundColor: "#f5f5f5",
  padding: "20px 0",
  position: "relative",
  whiteSpace: "nowrap",
});

const ExploreHead = styled(Typography)(() => ({
  fontSize: "40px",
  fontWeight: "600",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const ExploreBox = styled(Box)(() => ({
  marginLeft: "200px",
  marginTop: "50px",
  "@media (max-width: 768px)": {
    marginLeft: "0px",
  },
}));

const SectionBox = styled(Box)(() => ({
  display: "flex",
  gap: "30px",
}));

const Btn = styled(Button)(() => ({
  border: "1px #C10E14 solid",
  color: "#C10E14",
}));

const SearchSection = styled(Box)(() => ({
  display: "flex",
  marginTop: "30px",
  gap: "30px",
  "@media (max-width: 425px)": {
    gap: "5px",
  },
}));

const SearchBtn = styled(Button)(() => ({
  backgroundColor: "#000",
  color: "white",
  width: "150px",
  "@media (max-width: 425px)": {
    width: "100px",
  },
}));

const FreeholdSection = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  maxWidth: "1200px",
}));

const FreeholdHead = styled(Typography)(() => ({
  fontSize: "30px",
  fontWeight: 600,
  textAlign: "center",
  fontFamily: "'Poppins', sans-serif",
  marginBottom: "20px",
  "@media (min-width: 600px)": {
    fontSize: "34px",
  },
  "@media (min-width: 900px)": {
    fontSize: "40px",
    textAlign: "left",
  },
}));

const FreeholdContent = styled(Typography)(() => ({
  fontFamily: "'Poppins', sans-serif",
  fontSize: "16px",
  textAlign: "left",
  "@media (min-width: 600px)": {
    fontSize: "17px",
  },
  "@media (min-width: 900px)": {
    fontSize: "18px",
  },
  "@media (min-width: 1280px)": {
    fontSize: "20px",
  },
}));


const FreeholdBtn = styled(Button)(() => ({
  marginTop: "40px",
  border: "1px solid #C10E14",
  color: "#C10E14",
}));

const CardSectionHead = styled(Typography)(() => ({
  fontSize: "25px",
  marginLeft: "200px",
  "@media (max-width: 768px)": {
    marginLeft: "0px",
  },
}));

const CardBox1 = styled(Box)(() => ({
  display: "flex",
  gap: "40px",
  marginTop: "20px",
  justifyContent: "center",
  "@media (max-width: 425px)": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "20px",
  },
}));

const ViewAllBox = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  marginTop: "80px",
}));

const ViewAllBtn = styled(Button)(() => ({
  background: "black",
  color: "white",
}));

const ContactSectionBox = styled(Box)(() => ({
  marginLeft: "auto",
  marginRight: "auto",
  // maxWidth: "1200px",
}));

const ContactSectionHead = styled(Typography)(() => ({
  fontSize: "40px",
  fontWeight: "bold", 
  color: "white",
  "@media (max-width: 899px)": {
    textAlign: "center",
  },
}));

const ContactSectionbtnBox = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
}));

const ContactSectionbtn = styled(Button)(() => ({
  marginTop: "64px",
  background: "black",
  color: "white",
}));

const AddonDataHead = styled(Typography)(() => ({
  fontSize: "32px",
  fontWeight: 600,
  // fontFamily: "'Lora', serif;",
  fontFamily:" 'Futura', sans-serif",
  textAlign: "left",
  marginBottom: "20px", 
  color:"#C10E14",

  "@media (min-width: 600px)": {
    fontSize: "40px",
  },
  "@media (min-width: 900px)": {
    fontSize: "45px",
  },
  "@media (min-width: 1200px)": {
    fontSize: "48px",
  },
}));

const AddonDataContents = styled(Typography)(() => ({
  fontFamily: "'Poppins', sans-serif",
  textAlign: "left",
  marginBottom: "12px",
  lineHeight: 1.5,
  fontSize: "16px",

  "@media (min-width: 600px)": {
    fontSize: "18px",
  },
  "@media (min-width: 1200px)": {
    fontSize: "19px",
  },
  "@media (min-width: 1536px)": {
    fontSize: "20px",
  },
}));
const SectionHeader = styled(Typography)(({ theme }) => ({
  fontSize: "clamp(1.75rem, 3vw, 2.5rem)",
  fontWeight: 700,
  textAlign: "center",
  marginBottom: theme.spacing(4),
  position: "relative",
  "&::after": {
    content: '""',
    position: "absolute",
    bottom: -10,
    left: "50%",
    transform: "translateX(-50%)",
    width: "80px",
    height: "4px",
    backgroundColor: "#C10E14",
  },
}));



export {
  MainHeadWrap,
  MainHead,
  MainContent,
  ExploreHead,
  ExploreBox,
  SectionBox,
  Btn,
  SearchSection,
  SearchBtn,
  FreeholdSection,
  FreeholdHead,
  FreeholdContent,
  FreeholdBtn,
  CardSectionHead,
  CardBox1,
  ViewAllBox,
  ViewAllBtn,
  ContactSectionBox,
  ContactSectionHead,
  ContactSectionbtnBox,
  ContactSectionbtn,
  AddonDataHead,
  AddonDataContents,
  BrandMotionSection,
  SectionHeader
};
